module.exports = __webpack_public_path__ + "r-v3/img/q-pin_on.cbc39b89.svg";